export enum AuthEventType {
  //common
  FORM_START = 'formFillStart',
  FORM_SUBMIT = 'formSubmit',
  FIELD_INTERACTION = 'formFieldInteraction',
  FIELD_ERROR = 'formFieldError',
  LINK_CLICK = 'linkClick',
  CHAT = 'chatInitiated',
  SEEN_OFFER_PLACEMENT = 'seenOfferPlacement',
  SEEN_BEFH_PLACEMENT = 'seenBefhPlacement',
  SEEN_BANNER_PLACEMENT = 'seenBannerPlacement',
  MODAL_VIEW = 'modalView',
  //login
  LOGIN_ERROR = 'loginError',
  FORGOT_PASSWORD = 'initiateForgotUserPass',
  REGISTER = 'initiateRegister',
  CONTINUE_APP = 'initiateContinueApplication',
  //register
  FIND_USER_FAIL = 'initiateFindUserFail',
  FIND_USER_SUCCESS = 'initiateFindUserSuccess',
  REGISTRATION_SUCCESS = 'userRegistationSuccess',
  //forgot username
  USER_LOOKUP_FAIL = 'initiateUserLookupFail',
  USER_LOOKUP_SUCCESS = 'initiateUserLookupSuccess',
  FORGOT_USERNAME_EVENT = 'forgotUsername',
  // forgot password
  FORGOT_PASSWORD_EVENT = 'forgotPassword',
  NAVIGATE_TO_CSW = 'navigateToCsw',
  EXPERIMENT_SEEN = 'experimentSeen',
}

export enum AuthEventSource {
  AuthFrontend = 'auth-frontend',
}

export enum AuthEventRepo {
  Auth = 'auth',
  CustomerPortal = 'customerPortal',
}
